import "./styles.css";
import "./tailwind.css";
import { Router } from "./components/utils/Route";

function App() {
  return (
    <div className="App">
      <Router />
    </div>
  );
}

export default App;
